import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-4">
            <div className="mb-8">
              <h3 className="text-3xl font-bold tracking-wider mb-2">BRAVIA</h3>
              <h3 className="text-3xl font-bold tracking-wider">GROUP</h3>
            </div>
            <p className="text-gray-400 font-light leading-relaxed mb-8 max-w-sm">
              Construindo lares na Flórida com propósito, transparência e previsibilidade. Um hub de investidores focado em qualidade e entrega.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-white/30 flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-4 space-y-8">
            <div>
              <h4 className="text-xs font-medium tracking-widest mb-3 text-gray-500">ENDEREÇO</h4>
              <p className="text-white font-light leading-relaxed">
                Winter Garden - FL<br />
                United States
              </p>
            </div>
            <div>
              <h4 className="text-xs font-medium tracking-widest mb-3 text-gray-500">TELEFONE</h4>
              <p className="text-white font-light">+1 (689) 296-0820</p>
            </div>
            <div>
              <h4 className="text-xs font-medium tracking-widest mb-3 text-gray-500">EMAIL</h4>
              <p className="text-white font-light">braviagroupusa@gmail.com</p>
            </div>
          </div>

          <div className="md:col-span-4">
            <img
              src="https://public.readdy.ai/ai/img_res/9ee740819de00fe8455b4b433b617f78.jpg"
              alt="Construção Bravia Group"
              className="w-full h-80 object-cover object-top rounded-xl"
            />
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-500 font-light">
            © 2025 Bravia Group. Construindo lares com propósito.
          </p>
          <div className="flex items-center space-x-8">
            <Link to="/privacidade" className="text-sm text-gray-500 hover:text-white transition-colors whitespace-nowrap">
              Privacidade
            </Link>
            <Link to="/termos" className="text-sm text-gray-500 hover:text-white transition-colors whitespace-nowrap">
              Termos
            </Link>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
